module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/y5Uws3/tc-custom/9781459225534.jpg?1718106414052",
      "alt": "This image is the cover for the book Dakota Meltdown"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Dakota Meltdown\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("24/7")]), _c('br'), _c('br'), _vm._v("For investigator Brenna Jensen, snowy Riverton, North Dakota, was the ideal homeuntil it became the target of a serial killer. Not even FBI hotshot Nick Tarver could keep her from trailing the maniac who taunted her, shadowed her every move. Brenna was anything but comfortable with Nick, her bodyguard in black leather. The sexy lawman challenged her wounded heart. But as the snow melted and the body count rose, Nick’s arms became her only refuge. For Brenna had uncovered the hit listand her name was next.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Elle James\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Raised an Air Force brat, Elle James got her work ethic from her dad, creativity from mom and inspiration from her sister. As a member of the reserves, she's traveled, managed a career, and raised three children. She and her husband even raised ostriches and emus. Ask her what it's like to go toe-to-toe with a 350-pound bird! Former manager of computer programmers, Elle is happy to write full time in NW Arkansas.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0